import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import backgroundSvg from "@/assets/background.svg";

import {
  BookOpen,
  FileText,
  GraduationCap,
  Newspaper,
  ArrowRight,
} from "lucide-react";

const resources = [
  {
    icon: BookOpen,
    title: "Documentation",
    description:
      "Implementation guides and product documentation for your team.",
  },

  {
    icon: FileText,
    title: "Industry Guides",
    description:
      "Learn how businesses improve operations, compliance and revenue performance with Eaze.",
  },

  {
    icon: GraduationCap,
    title: "Eaze Academy",
    description:
      "Training resources, certifications and onboarding programs for users and administrators.",
  },

  {
    icon: Newspaper,
    title: "Insights & Updates",
    description:
      "Industry trends, product updates and thought leadership from the Eaze team.",
  },
];

const Resources = () => {
  return (
    <section id="resources" className="relative overflow-hidden py-28">
      {/* Background */}
      <div className="absolute inset-0 -z-10">
        <img
          src={backgroundSvg}
          alt=""
          className="w-full h-full object-cover opacity-20"
        />

        <div className="absolute inset-0 bg-gradient-to-br from-[#0A2540] to-[#0E2C44]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-4xl mx-auto text-center"
        >
          <span className="inline-flex items-center rounded-full border border-white/20 bg-white/10 px-4 py-2 text-sm font-medium text-white">
            RESOURCES
          </span>

          <h2 className="mt-6 text-4xl md:text-6xl font-bold tracking-tight text-white">
            Learn. Build. Transform.
          </h2>

          <p className="mt-6 text-lg md:text-xl text-slate-300 leading-relaxed">
            Everything you need to successfully implement, manage and scale your
            business with Eaze.
          </p>
        </motion.div>

        {/* Cards */}

        <div className="mt-20 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
          {resources.map((resource, index) => {
            const Icon = resource.icon;

            return (
              <motion.div
                key={resource.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.5,
                  delay: index * 0.1,
                }}
                className="
                  group
                  rounded-3xl
                  border
                  border-white/10
                  bg-white/5
                  backdrop-blur-sm
                  p-8
                  hover:bg-white/10
                  hover:border-[#4CAF50]/30
                  transition-all
                "
              >
                <div className="w-14 h-14 rounded-2xl bg-[#4CAF50]/10 flex items-center justify-center">
                  <Icon className="w-7 h-7 text-[#4CAF50]" />
                </div>

                <h3 className="mt-6 text-2xl font-bold text-white">
                  {resource.title}
                </h3>

                <p className="mt-4 text-slate-300 leading-relaxed">
                  {resource.description}
                </p>

                {/* <button className="mt-8 flex items-center gap-2 text-[#4CAF50] font-semibold">
                  coming soon
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </button> */}
              </motion.div>
            );
          })}
        </div>

        {/* Bottom CTA */}

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="
            mt-20
            rounded-3xl
            border
            border-white/10
            bg-white/5
            backdrop-blur-sm
            p-10
            text-center
          "
        >
          <h3 className="text-3xl md:text-4xl font-bold text-white">
            Ready to transform your business?
          </h3>

          <p className="mt-4 text-slate-300 max-w-2xl mx-auto">
            Explore Eaze, schedule a demo, or speak with our team about your
            business requirements.
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Link
              to="/book-demo"
              className="px-6 py-3 rounded-xl bg-[#4CAF50] text-white font-semibold hover:bg-[#45A049] transition"
            >
              Book a demo
            </Link>

            {/* <button className="px-6 py-3 rounded-xl border border-white/20 text-white hover:bg-white/10 transition">
              View Documentation
            </button> */}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Resources;
